'use strict';

/* global angular */

require('./settings');
require('./manager');
require('./uploader');
require('./dash');
require('./login');
require('./resources');
require('./dialogs');
require('./requireCompleteSignIn');

require('@skycatch/saturn-growl-booster');
require('@skycatch/saturn-autohide-booster');
require('@skycatch/saturn-mapboxgl-booster');

require('angular-clipboard');
require('angular-google-gapi');
require('angular-sanitize');

var app = angular.module('app', [
  'app.dialogs',
  'angular.filter',
  'gettext',
  'ngSanitize',
  'ui.bootstrap',
  'ui.router',
  'angular-google-gapi',
  'saturn',
  'saturn-growl',
  'saturn-autohide',
  'saturn-mapboxgl-booster',
  'common',
  'app.templates',
  'angularUtils.directives.dirPagination',
  'app.resources',
  'settings',
  'manager',
  'uploader',
  'dash',
  'login',
  'requireCompleteSignIn',
  // 'ingestor'
]);

var AppConfig = require('./AppConfig');
var AppController = require('./AppController');
var AppService = require('./AppService');

app.config(AppConfig);

app.constant('APP_DISPATCHER_ID', 'Skydash');

// ## Controllers
app.controller('AppController', AppController);

// ## Services
app.service('AppService', AppService);

// ## Flux Actions and Store
app.factory('AppActions', require('./AppActions'));
app.factory('AppStore', require('./AppStore'));
app.run(['AppStore', function (AppStore) {
  AppStore.init();
}]);

// We should enable this in production for a significant performance boost
// To view debug data in production once this is enabled
// call `angular.reloadWithDebugInfo()` from the console
// Never use comment or CSS class directives
// https://docs.angularjs.org/guide/production
// app.config(['$compileProvider', function ($compileProvider) {
//   $compileProvider.debugInfoEnabled(false);
//   $compileProvider.commentDirectivesEnabled(false);
//   $compileProvider.cssClassDirectivesEnabled(false);
// }]);

// ## Load Language
app.run(['gettextCatalog', function (gettextCatalog) {
  var lang = 'en';
  gettextCatalog.debug = false;
  gettextCatalog.setCurrentLanguage(lang);
  gettextCatalog.loadRemote('/languages/' + lang + '.json');
}]);

app.run(['SocialLoginService',
  function(SocialLoginService) {
    SocialLoginService.loadGoogle();
    SocialLoginService.loadFacebook();
  }
]);

// ## Inject Angular Constants into the rootScope
app.run(['$rootScope', 'stripe_public', 'assets_domain', function ($rootScope, stripe_public, assets_domain) {
  $rootScope.CONST = {};
  $rootScope.CONST.stripe_public = stripe_public;
  $rootScope.CONST.assets_domain = assets_domain;
  $rootScope.CONST.cloud_services_agreement_url = 'https://support.skycatch.com/hc/en-us/articles/218310297';
}]);

app.run(['RavenService', function (RavenService) {
  RavenService.syncUser();
}]);

app.run(['IngestorService', (IngestorService) => {
  IngestorService.init();
  IngestorService.setService(IngestorService)
}]);




// WEBPACK FOOTER //
// ./src/app/index.js